import "./timeline-comp.css";
import { useTranslation } from "react-i18next";

export default function Timeline({timelineData}) {
  const {t} = useTranslation();
  return (
    <section className="timeline-section">
      <div className="timeline">
        <div className="timeline-line"></div>
        {timelineData.map((item, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"} in-view`}
          >
            <div className="timeline-marker"></div>
            <div className="timeline-card">
              <span className="timeline-date">{item.date}</span>
              <h3 className="timeline-title">{t(item.title)}</h3>
              <p className="timeline-content">{t(item.content)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
